import React, { useState } from 'react';

export function useSort(defaultKey = null, defaultDir = 'asc') {
  const [sort, setSort] = useState({ key: defaultKey, dir: defaultDir });
  const toggle = (key) => setSort(prev => ({
    key,
    dir: prev.key === key && prev.dir === 'asc' ? 'desc' : 'asc',
  }));
  return [sort, toggle];
}

function cmp(a, b) {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return String(a).toLowerCase().localeCompare(String(b).toLowerCase());
}

export function sortRows(rows, sort, getVal) {
  if (!sort.key) return rows;
  return [...rows].sort((a, b) => {
    const r = cmp(getVal(a, sort.key), getVal(b, sort.key));
    return sort.dir === 'asc' ? r : -r;
  });
}

export function SortTh({ children, sortKey, sort, onSort, style, title, className, filter }) {
  const active = sort.key === sortKey;
  return (
    <th
      className={`th-sortable${className ? ' ' + className : ''}`}
      onClick={() => onSort(sortKey)}
      style={style}
      title={title}
    >
      <span className="th-inner">
        {children}
        <span className={`th-arrow${active ? ' th-arrow-active' : ''}`}>
          {active ? (sort.dir === 'asc' ? '↑' : '↓') : '↕'}
        </span>
        {filter}
      </span>
    </th>
  );
}
